import React from 'react';
import { Box } from 'bonfire-kindling';

const StepConnector = props => <Box bgcolor="purple.main" width="20px" height="2px" {...props} />;

export default StepConnector;
